import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

/**
 * Tooltips on the calendar page (calendar, appointment list, tasks): shown only after the pointer rests on an item for
 * 0.7 seconds, so moving across a busy calendar does not flash one after another. Touch gestures are off: a tooltip's
 * touch handling sets touch-action: none on its element, so a swipe starting on a booking or row would not scroll.
 */
export const CALENDAR_TOOLTIPS = {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: { showDelay: 700, hideDelay: 0, touchendHideDelay: 1500, touchGestures: 'off' } as MatTooltipDefaultOptions,
};
